(() => {
  const init = root =>
    root.querySelectorAll('[data-artist-directory]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const grid = section.querySelector('[data-directory-grid]');
      const count = section.querySelector('[data-directory-count]');
      const search = section.querySelector('[data-directory-search]');
      const message = section.querySelector('[data-directory-message]');
      const messageText = section.querySelector('[data-directory-message-text]');
      const retry = section.querySelector('[data-directory-retry]');
      let artists = [];
      const normalize = value =>
        value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      const element = (tag, name, text) => {
        const el = document.createElement(tag);
        el.className = `dga-directory__${name}`;
        if (text) el.textContent = text;
        return el;
      };
      const card = artist => {
        const article = element('article', 'card');
        const link = element('a', 'link');
        link.href = `https://marketplace.darkgloomyart.com/u/${artist.id}`;
        const portrait = element('div', 'portrait');
        portrait.setAttribute('aria-hidden', 'true');
        const initials = () =>
          portrait.replaceChildren(
            element(
              'span',
              'initials',
              artist.name
                .trim()
                .split(/\s+/)
                .slice(0, 2)
                .map(part => [...part][0])
                .join('')
                .toUpperCase()
            )
          );
        initials();
        try {
          const url = new URL(artist.imageUrl);
          if (url.protocol === 'https:') {
            const image = element('img', 'image');
            image.alt = '';
            image.width = 156;
            image.height = 156;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.addEventListener('error', initials, { once: true });
            image.src = url.href;
            portrait.replaceChildren(image);
          }
        } catch (_) {
          /* Profiles without photographs retain their initials. */
        }
        const identity = element('div', 'identity');
        const details = element('div', 'details');
        details.append(element('h3', 'name', artist.name));
        if (artist.location) details.append(element('p', 'location', artist.location));
        identity.append(portrait, details);
        link.append(identity);
        const bio = typeof artist.bio === 'string' ? artist.bio.trim() : '';
        const excerpt =
          bio.length > 235
            ? `${bio
                .slice(0, 235)
                .replace(/\s+\S*$/, '')
                .replace(/[.,;:!?]+$/, '')}…`
            : bio;
        link.append(
          element(
            'p',
            'bio',
            excerpt ||
              'Explore this artist’s published work and discover more on their marketplace profile.'
          )
        );
        if (Number.isInteger(artist.listingCount) && artist.listingCount > 0)
          link.append(
            element(
              'p',
              'works',
              `${artist.listingCount} ${
                artist.listingCount === 1 ? 'listing' : 'listings'
              } on the marketplace`
            )
          );
        const cta = element('span', 'cta', 'Explore Artist');
        const arrow = element('span', 'arrow', '↗');
        arrow.setAttribute('aria-hidden', 'true');
        cta.append(arrow);
        link.append(cta);
        article.append(link);
        return article;
      };
      const render = () => {
        const query = normalize(search.value.trim());
        const matches = artists.filter(artist =>
          normalize(`${artist.name} ${artist.location || ''} ${artist.bio || ''}`).includes(query)
        );
        grid.replaceChildren(...matches.map(card));
        count.textContent = query
          ? `${matches.length} of ${artists.length} artists`
          : `${artists.length} artists · A–Z`;
        message.hidden = matches.length > 0;
        messageText.textContent = artists.length
          ? 'No artists found. Try a different name or location.'
          : 'Artists will appear here when their work is published on the marketplace.';
        retry.hidden = true;
      };
      const load = async () => {
        retry.disabled = true;
        message.hidden = true;
        count.textContent = 'Loading artists…';
        grid.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(section.dataset.feed, {
            credentials: 'omit',
            signal: controller.signal,
          });
          if (!response.ok) throw new Error('Unavailable');
          const payload = await response.json();
          if (!Array.isArray(payload.artists)) throw new Error('Invalid response');
          const seen = new Set();
          artists = payload.artists
            .filter(a => {
              if (
                !a ||
                !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(a.id) ||
                typeof a.name !== 'string' ||
                !a.name.trim() ||
                seen.has(a.id)
              )
                return false;
              seen.add(a.id);
              return true;
            })
            .sort((a, b) => a.name.localeCompare(b.name, 'en'));
          section.querySelector('[data-directory-search-wrap]').hidden = false;
          render();
        } catch (_) {
          count.textContent = 'Directory temporarily unavailable';
          messageText.textContent =
            'We couldn’t load the artists. Please try again, or explore the marketplace below.';
          message.hidden = false;
          retry.hidden = false;
        } finally {
          clearTimeout(timeout);
          retry.disabled = false;
          grid.setAttribute('aria-busy', 'false');
        }
      };
      search.addEventListener('input', render);
      retry.addEventListener('click', load);
      load();
    });
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
